export default "__VITE_ASSET__CnDSk59h__"